import { ConnectDragSource } from 'react-dnd';

import CloseImg from 'assets/close.png';
import Visible from 'coreOld/components/Visible';
import { IPill } from 'partsOld/types';

import { Icon, Wrapper } from './pillStyles';
import { useDragAndDrop } from '../useDragAndDrop';

interface IProps {
  drag: ConnectDragSource;
  isDragging: boolean;
  showCloseIcon?: boolean;
  pill: IPill;
}

const PillView = ({ pill, drag, isDragging, showCloseIcon = false }: IProps) => {
  const { removePills } = useDragAndDrop();

  return (
    <Wrapper ref={drag} isDragging={isDragging} showCloseIcon={showCloseIcon}>
      {pill.name}

      <Visible when={showCloseIcon}>
        <Icon
          src={CloseImg}
          onClick={(e) => {
            e.preventDefault();
            removePills([pill]);
          }}
        />
      </Visible>
    </Wrapper>
  );
};
export default PillView;
